import { InventoryItem } from './api';
export interface PlanningItem extends InventoryItem {
  stock_known: boolean; stock_version: number; last_count_at: string | null;
  pack_size: string | null; historical_order_count: number | null;
  consumption: number | null; observed_days: number | null; waste: number | null;
  anomaly_count: number | null; short_interval_count: number | null;
  weekly_consumption: number | null; suggested_target: number | null;
  invoice_average_price: number | null; invoice_latest_price: number | null;
  purchase_spend: number | null; purchased_quantity: number | null; invoice_count: number | null;
  order_reason: string | null; order_packs: number | null; order_quantity: number | null;
  estimated_order_cost: number | null; count_age_days: number | null;
}
export interface PlanningData {
  items: PlanningItem[]; days: number;
  count_history: {id:number;counted_at:string;notes:string;counted_by:string;item_count:number}[];
}
export interface CountRequest {request_id:string;notes:string;lines:{item_id:number;stock_version:number;quantity:number}[];}
export class PlanningError extends Error { constructor(message:string,public status:number) { super(message); } }
async function request<T>(token:string|null,path:string,method='GET',body?:unknown):Promise<T> {
  const response=await fetch(`/api/v2/inventory-planning${path}`,{method,cache:'no-store',headers:{'X-Session-Token':token || '','Content-Type':'application/json'},body:body===undefined?undefined:JSON.stringify(body)});
  const data=await response.json();
  if (!response.ok) throw new PlanningError(data.error || 'Unable to complete request.',response.status);
  return data;
}
export const getPlanning=(token:string|null,days=90)=>request<PlanningData>(token,`?days=${days}`);
export const saveStockCounts=(token:string|null,body:CountRequest)=>request<{batch_id:number;item_count:number}>(token,'/counts','POST',body);
export const saveTarget=(token:string|null,item:PlanningItem,par:number|null)=>request<{item:PlanningItem}>(token,'/target','PATCH',{item_id:item.id,stock_version:item.stock_version,par_level:par});

const csvCell=(value:unknown)=>`"${String(value ?? '').replace(/^[=+@-]/,"'$&").replace(/"/g,'""')}"`;
export function orderCsv(items:PlanningItem[]) {
  const lines=[['Supplier','Item code','Item','Pack size','Current stock','Stock unit','Target','Packs to order','Quantity to order','Estimated CAD (before tax)']];
  items.filter(i=>i.order_packs!=null && i.order_packs>0).forEach(i=>lines.push([
    i.supplier_name || '',i.supplier_sku || i.sku || '',i.name,i.pack_size || i.purchase_unit || '',
    String(i.on_hand_quantity),i.base_unit,String(i.par_level),String(i.order_packs),String(i.order_quantity),
    i.estimated_order_cost==null?'Price unavailable':Number(i.estimated_order_cost).toFixed(2),
  ]));
  return '\uFEFF'+lines.map(row=>row.map(csvCell).join(',')).join('\r\n');
}
